import React, { memo } from 'react';
import styled from 'styled-components';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useTheme } from '../../hooks/useTheme';

const Header = styled.header.attrs({
  className: 'w-full flex justify-end items-center',
})`
  position: relative;
  height: 54px;
  padding: 0;
  background: ${props => props.theme.colors.header.background};
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  & > i, & > span {
    margin: 0 10px;
  }
`;

const DashboardHeader = () => {
  const { colors } = useTheme();
  
  return (
    <Header className="cursor-pointer">
      <span className="flex items-center space-around ml-4 mr-4" href="#">
        <Avatar style={{ backgroundColor: colors.special.avatar, marginRight: 5 }} size="small" icon={<UserOutlined />} />
        <span className="text-xs">User</span>
      </span>
    </Header>
  );
};

export default memo(DashboardHeader);
